import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import { LocalizationTextOverrideInputSchema } from "./save-localization-text-overrides";

export const translateShopifyCoverageText = {
  name: "translateShopifyCoverageText" as const,
  input: z.object({
    teamId: zExt.objectId(),
    sourceLocale: z.string().min(2).max(35),
  }),
  output: z.object({
    drafts: z.array(
      z.object({
        language: z.string().regex(/^[a-z]{2,3}$/),
        textOverrides: z.array(
          LocalizationTextOverrideInputSchema.and(
            z.object({ sourceText: z.string() }),
          ),
        ),
      }),
    ),
    failedLanguages: z.array(z.string()),
  }),
};
